<mat-form-field
    [appearance]="appearance$$()"
    [class.show-error]="control$$().invalid && errorShow$$()"
    [class.show-hint]="hint$$() || hintLabel$$()"
    [color]="color$$()"
    [floatLabel]="floatLabel$$()"
    [hideRequiredMarker]="hideRequiredMarker$$()"
    [hintLabel]="hintLabel$$()"
    [ngClass]="classHeight$$()"
    [subscriptSizing]="subscriptSizing$$()">

    @if (!!label$$()) {
        <mat-label>{{label$$()}}:</mat-label>
    }
    @if (!!hint$$()) {
        <mat-hint [align]="hintAlign$$()">{{hint$$()}}</mat-hint>
    }
    @if (control$$().invalid && errorShow$$()) {
        <mat-error>{{errorMessage_getFirst()}}</mat-error>
    }

    <mat-select inputBox
        (openedChange)="emit_openedChange($event)"
        (selectionChange)="emit_selectionChange($event.value)"
        (valueChange)="emit_valueChange($event)"
        [aria-label]="input_ariaLabel$$()"
        [aria-labelledby]="input_ariaLabelledBy$$()"
        [attributes]="attributes$$()"
        [canSelectNullableOptions]="input_canSelectNullableOptions$$()"
        [compareWith]="compareWith$$()"
        [disableOptionCentering]="input_disableOptionCentering$$()"
        [disableRipple]="input_disableRipple$$()"
        [errorStateMatcher]="errorStateMatcher$$()"
        [formControl]="control$$()"
        [hideSingleSelectionIndicator]="input_hideSingleSelectionIndicator$$()"
        [id]="id$$()"
        [multiple]="input_multiple$$()"
        [panelClass]="input_panelClass$$()"
        [panelWidth]="input_panelWidth$$()"
        [placeholder]="placeholder$$()"
        [required]="required$$()"
        [sortComparator]="sortComparator$$()"
        [typeaheadDebounceInterval]="input_typeAheadDebounceInterval$$()"
    >
        @for (item of input_list$$(); track trackValue(item)) {
            <mat-option [value]="item">
                {{itemText(item)}}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
